import axios from "axios";
import { Form } from "devextreme-react";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import DataSource from "devextreme/data/data_source";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import NotificationComponent from "./NotificationComponent";
import {
  updateCat,
  updateDueDate,
  updateStartDate,
  updateTitle,
  // updateTrainee,
  updateType,
} from "./Redux/Tracker";

const TrackerFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function TrainingTrackerForm(props) {
  const { trainingTracker, formTrackerRef } = props;

  const dispatch = useDispatch();

  const [employeeDataSource, setEmployeeDataSource] = useState(null);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/employee?tenure=1`)
      .then((result) => {
        setEmployeeDataSource(
          new DataSource({
            store: {
              type: "array",
              data: result.data,
              key: "employeeNo",
            },
            group: "div",
          })
        );
      });
  }, []);

  useEffect(() => {
    if (trainingTracker.trainee) {
      const formData = formTrackerRef.current.instance.option("formData");

      formTrackerRef.current.instance.option("formData", {
        ...formData,
        trainee: trainingTracker.trainee.map((trainee) => trainee.trainee),
      });
    }
  }, [trainingTracker.trainee]);

  const displayExprEmployee = (item) => {
    if (item) {
      return `${item.name} (${item.employeeNo})`;
    } else {
      return null;
    }
  };

  const onTypeValueChanged = (e) => {
    dispatch(
      updateType({
        type: e.value,
      })
    );
  };

  const onCatValueChanged = (e) => {
    dispatch(
      updateCat({
        cat: e.value,
      })
    );
  };

  const onTitleValueChanged = (e) => {
    dispatch(
      updateTitle({
        title: e.value,
      })
    );
  };

  const onStartDateValueChanged = (e) => {
    dispatch(
      updateStartDate({
        startDate: e.value,
      })
    );
  };

  const onDueDateValueChanged = (e) => {
    dispatch(
      updateDueDate({
        dueDate: e.value,
      })
    );
  };

  // const onTraineeValueChanged = (e) => {
  //   dispatch(
  //     updateTrainee({
  //       trainee: e.value,
  //     })
  //   );
  // };

  // const onTraineeValueChanged = (e) => {
  //   console.debug("[onTraineeValueChanged");
  //   console.debug("e.value", e.value);
  //   // dispatch(
  //   //   updateTrainee({
  //   //     trainee: e.value,
  //   //   })
  //   // );

  //   dispatch(
  //     updateTrainee({
  //       trainee: e.value,
  //     })
  //   );
  // };

  return (
    <TrackerFormWrapper>
      <Form
        ref={formTrackerRef}
        colCount={4}
        labelMode={"outside"}
        labelLocation={"top"}
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup={"trackerData"}
      >
        {/* <SimpleItem
          dataField="type"
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: TYPE_INTERNAL,
            valueExpr: "id",
            displayExpr: "name",
            showClearButton: true,
            value: trainingTracker.type,
            onValueChanged: onTypeValueChanged,
          }}
        >
          <Label text={"Training Type"} />
          <RequiredRule message={"* Training Type을 입력해주세요."} />
        </SimpleItem> */}
        {/* <SimpleItem
          dataField="cat"
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: CAT,
            valueExpr: "id",
            displayExpr: "name",
            showClearButton: true,
            value: trainingTracker.cat,
            onValueChanged: onCatValueChanged,
          }}
        >
          <Label text={"Category"} />
          <RequiredRule message={"* Category를 입력해주세요."} />
        </SimpleItem> */}
        <SimpleItem
          dataField={"title"}
          editorType={"dxTextBox"}
          editorOptions={{
            showClearButton: true,
            value: trainingTracker.title,
            onValueChanged: onTitleValueChanged,
          }}
          colSpan={2}
        >
          <Label text={"Title"} />
          <RequiredRule message={"* Title을 입력해주세요."} />
        </SimpleItem>
        <SimpleItem
          dataField={"startDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            type: "date",
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            value: trainingTracker.startDate,
            onValueChanged: onStartDateValueChanged,
          }}
        >
          <Label text={"Start Date"} />
          <RequiredRule message={"* Start Date를 입력해주세요."} />
        </SimpleItem>
        <SimpleItem
          dataField={"dueDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            type: "date",
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            value: trainingTracker.dueDate,
            onValueChanged: onDueDateValueChanged,
          }}
        >
          <Label text={"Due Date"} />
          <RequiredRule message={"* Due Date를 입력해주세요."} />
        </SimpleItem>

        <SimpleItem
          dataField={"trainee"}
          colSpan={3}
          editorType={"dxTagBox"}
          editorOptions={{
            dataSource: employeeDataSource,
            displayExpr: displayExprEmployee,
            valueExpr: "employeeNo",
            grouped: true,
            showSelectionControls: true,
            applyValueMode: "useButtons",
            searchEnabled: true,
            showClearButton: true,
            // value: trainingTracker.trainee,
            // onValueChanged: onTraineeValueChanged,
          }}
        >
          <Label text={"Trainee"} />
          <RequiredRule message={"* 학습자들을 선택해주세요."} />
        </SimpleItem>
        {/* <SimpleItem
          dataField={"admin"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: employeeDataSource,
            valueExpr: "employeeNo",
            grouped: true,
            displayExpr: displayExprEmployee,
            // displayExpr: "name",
            readOnly: true,
            // defaultValue: userInfo.employeeNo,
            value: trainingTracker.admin,
          }}
        >
          <Label text={"Administrator"} />
        </SimpleItem> */}
        <SimpleItem>
          <Label text={"알림"} />
          <NotificationComponent trainingTracker={trainingTracker} />
        </SimpleItem>
      </Form>
    </TrackerFormWrapper>
  );
}
